import { isBackofficeStore } from '@/store/CommercialCombinedFormStore'

export const backOfficeUrl = '/back-office'
export const brokerUrl = '/broker'

export function useRouterArea() {
  const { backoffice } = isBackofficeStore.getState()

  const urlPrefix = backoffice ? `${backOfficeUrl}` : `${brokerUrl}`

  return {
    isBackOffice: backoffice,
    isBroker: !backoffice,
    urlPrefix,
  }
}
